import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCompareFields = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 22 22",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		fill: "#FFF",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("path", { d: "M14.089 10.688a.844.844 0 010-1.191.844.844 0 011.19 0l4.17 4.169a.844.844 0 010 1.19l-4.17 4.17a.844.844 0 01-1.19 0 .844.844 0 010-1.192l2.733-2.733-6.309.004a.843.843 0 11.004-1.688l6.303.002-2.731-2.731zM7.16 2.868a.844.844 0 010 1.19L4.425 6.793l6.308-.004a.843.843 0 11-.003 1.688l-6.303-.002 2.731 2.732a.844.844 0 010 1.19.844.844 0 01-1.19 0l-4.17-4.168a.844.844 0 010-1.191l4.17-4.17a.844.844 0 011.19 0z" })
	})
});
export default SvgCompareFields;
